import { render } from "./TemplateManage.vue?vue&type=template&id=4eae4ad9&scoped=true"
import script from "./TemplateManage.vue?vue&type=script&lang=js"
export * from "./TemplateManage.vue?vue&type=script&lang=js"

import "./TemplateManage.vue?vue&type=style&index=0&id=4eae4ad9&lang=less&scoped=true"
import "./TemplateManage.vue?vue&type=style&index=1&id=4eae4ad9&lang=less"
import "./TemplateManage.vue?vue&type=style&index=2&id=4eae4ad9&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eae4ad9"]])

export default __exports__